import { c as _c } from "react/compiler-runtime";
import { SectionTitle } from "../components/common/SectionTitle";
import { ExperiencesGrid } from "../components/experiences/ExperiencesGrid";
import { ExperiencesList } from "../components/experiences/ExperiencesList";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function ExperiencesSearchView(t0) {
  const $ = _c(16);
  const {
    experiences,
    query
  } = t0;
  if (!query) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = /*#__PURE__*/_jsx(SectionTitle, {
        accentPosition: "bottom",
        className: "mb-6",
        children: "S\xF6k upplevelser"
      });
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = /*#__PURE__*/_jsx("main", {
        className: "pt-24 md:pt-28",
        children: /*#__PURE__*/_jsxs("div", {
          className: "container mx-auto px-4 sm:px-6 lg:px-8",
          children: [t1, /*#__PURE__*/_jsx("div", {
            className: "mt-12 text-center",
            children: /*#__PURE__*/_jsx("p", {
              className: "text-lg text-muted-foreground",
              children: "Anv\xE4nd s\xF6kfunktionen i sidhuvudet f\xF6r att hitta upplevelser"
            })
          })]
        })
      });
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  const hasResults = experiences.length > 0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsx(SectionTitle, {
      accentPosition: "bottom",
      className: "mb-6",
      children: "S\xF6k upplevelser"
    });
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = hasResults ? `Hittade ${experiences.length} resultat för "${query}"` : `Inga resultat för "${query}"`;
  let t3;
  if ($[3] !== t2) {
    t3 = /*#__PURE__*/_jsx("h2", {
      className: "text-lg font-medium",
      children: t2
    });
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== hasResults) {
    t4 = !hasResults && /*#__PURE__*/_jsx("p", {
      className: "mt-2 text-muted-foreground",
      children: "Vi kunde inte hitta n\xE5gra upplevelser som matchar din s\xF6kning."
    });
    $[5] = hasResults;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = /*#__PURE__*/_jsxs("div", {
      className: "mb-8",
      children: [t3, t4]
    });
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== experiences || $[11] !== hasResults) {
    t6 = hasResults && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: "block md:hidden",
        children: /*#__PURE__*/_jsx(ExperiencesList, {
          experiences: experiences,
          count: 20
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "hidden md:block",
        children: /*#__PURE__*/_jsx(ExperiencesGrid, {
          experiences: experiences,
          size: "regular"
        })
      })]
    });
    $[10] = experiences;
    $[11] = hasResults;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = /*#__PURE__*/_jsx("main", {
      className: "pt-24 md:pt-28",
      children: /*#__PURE__*/_jsxs("div", {
        className: "container mx-auto px-4 sm:px-6 lg:px-8",
        children: [t1, t5, t6]
      })
    });
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}